import { Login_service } from "../services/Login_service";
import router from "../router/router";
import { MessageBox } from "element-ui";
import moment from 'moment';
import config from "../../config/config"

const state = {
    username: "",
    activate: false,
    avitvate_username: "",
    banner_info : {
        banner_img: "",
        updated_by : "",
        updated_at : "",
        active_status : "",
        start_date : "",
        end_date : ""
    },
    website_banner_info : {
        banner_img: "",
        updated_by : "",
        updated_at : "",
        active_status : "",
        start_date : "",
        end_date : ""
    },
    cms_banner_visible : false,
    login_pending : false
}

const actions = {
    async login({ commit }, data) {
        commit('SET_LOGIN_PENDING', true)
        setTimeout(()=>{
            commit('SET_LOGIN_PENDING', false)
        }, 3000)
        let ad_authen = (process.env.NODE_ENV == "production" || process.env.NODE_ENV == "staging") ? await Login_service.ad_authenticate({ username : data.username+'@nbtc.domain', password : data.password, lang : 'th'}) : {status: 500};
        let result = ad_authen.status == 200 ? await Login_service.ad_login(data) : await Login_service.login(data)
        if(result.status !== 200){
            commit('SET_LOGIN_PENDING', false)
            if (result.data != null && result.data.forgot_token != null) {
                return MessageBox.confirm(result.message,"แจ้งเตือน", {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: "warning"
                }).then(() => {
                    router.push({ name: 'Reset_password', params: { forgot_token: result.data.forgot_token } })
                }).catch()
            } else {
                return MessageBox.confirm(result.message, "แจ้งเตือน", {
                    confirmButtonText: "ตกลง",
                    showCancelButton: false,
                    type: "warning"
                });
            }
        }else{
            commit('SET_LOGIN_PENDING', false)
        }
        let userdata = result.data
        let permission = btoa(userdata.permission)
        $cookies.set("user_nbtc", {
            token: userdata.token,
            admin_id: userdata.admin_id,
            fullname: userdata.fullname,
            provider_id: userdata.provider_id,
            provider_type: userdata.provider_type,
            profileImg: userdata.profileImg,
            date: userdata.date,
            remember : userdata.remember,
            permission: permission
        },{ expires: 60*30 });
        $cookies.set("procheck_timeout", {
            timeout: moment(new Date).add(30, 'minute')
        })
        if (userdata.remember) {
            $cookies.set("remember_procheck", {
                remember: userdata.remember,
                username: userdata.username
            });
        } else {
            if ($cookies.isKey("remember_procheck")) {
                $cookies.get("remember_procheck").username == data.username ? $cookies.remove("remember_procheck") : null;
            }
        }
        if (userdata.provider_id) {
            router.push({ name: "DashboardOperator" })
        } else {
            router.push({ name: "DashboardAdmin" })
        }
    },
    logout({ commit }, data) {
        let tk = $cookies.get("user_nbtc");
        let logout = Login_service.logout(tk.token);
        logout.subscribe({
            error: function(err) {
                if (err.status === 230 || err.status === 225) {
                    MessageBox.confirm(err.message, "แจ้งเตือน", {
                            confirmButtonText: "ตกลง",
                            showCancelButton: false,
                            type: "warning"
                        })
                        .then(() => {
                            $cookies.remove("user_nbtc");
                            router.push({
                                name: "Login"
                            });
                        })
                        .catch(() => {
                            $cookies.remove("user_nbtc");
                            router.push({
                                name: "Login"
                            });
                        });
                } else {
                    MessageBox.confirm(err.message, "แจ้งเตือน", {
                            confirmButtonText: "ตกลง",
                            showCancelButton: false,
                            type: "warning"
                        })
                        .then(() => {})
                        .catch(() => {});
                }
            },
            next: function(data) {
                $cookies.remove("user_nbtc");
                router.push({
                    name: "Login"
                });
            },
            complete: function(data) {
                // console.log(data);
            }
        });
    },
    async forget({ commit }, data) {
        const regex = /\@nbtc\.domain$/
        if(!!regex.exec(data.username.toLowerCase())){
            return  MessageBox.confirm('ไม่พบข้อมูลผู้ใช้งาน', "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    });
        }
        let result = await Login_service.forget(data);
        if (result.status === 200) {
            MessageBox.confirm("ข้อมูลของคุณถูกส่งไปยังอีเมลเรียบร้อยแล้ว", "แจ้งเตือน", {
                    confirmButtonText: "ตกลง",
                    showCancelButton: false,
                    type: "success"
                })
                .then(() => {
                    router.push({
                        name: "Login"
                    });
                })
                .catch(() => {
                    router.push({
                        name: "Login"
                    });
                });
        } else {
            MessageBox.confirm('ไม่พบข้อมูลผู้ใช้งาน', "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                type: "warning"
            });
        }
    },
    async activate({ commit }, data) {
        let result = await Login_service.activate(data);
        if (result.status === 200) {
            state.activate_username = result.data
            state.activate = true;
        } else {
            state.activate = false;
        }
    },
    async reset_password({commit}, data) {
        let result = await Login_service.resetPassword(data)
        if (result.status == 200) {
            MessageBox.confirm(result.message, "สำเร็จ", {
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                type: "success"
            }).then(() => {
                router.push({
                    name: "Login"
                });
            })
        } else {
            MessageBox.confirm(result.message, "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                type: "warning"
            })
        }
    },
    async get_banner({commit}, type){
        let result = await Login_service.get_banner(type)
        if(result.status == 200){
            for(let item of result.data){
                if(item.banner_type == 'cms'){
                    let banner_info = item
                    commit('SET_BANNER', banner_info)
                    if(banner_info.active_status == '1'){
                        var today = moment().format('YYYY-MM-DD')
                        var start = banner_info.start_date ? moment(banner_info.start_date).format('YYYY-MM-DD') : undefined
                        var end = banner_info.end_date ? moment(banner_info.end_date).format('YYYY-MM-DD') : undefined
                        if(moment(today).isBetween(start, end, undefined, [])){
                            if($cookies.get('banner')){
                                if($cookies.get('banner').disabled !== today){
                                    commit('SET_BANNER_VISIBLE', true)
                                }
                            }else{
                                commit('SET_BANNER_VISIBLE', true)
                            }
                        }
                    }
                }else{
                    commit('SET_WEBSITE_BANNER', item)
                }
            }
        }else {
            MessageBox.confirm(result.message, "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                type: "warning"
            })
        }
    },
    async update_banner({commit}, formdata){
        let result = await Login_service.update_banner(formdata)
        if(result.status == 200){
            MessageBox.confirm("แก้ไขข้อมูลเรียบร้อย", "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                type: "success"
            }).then(()=>{
                for(let item of result.data){
                    if(item.banner_type == 'cms'){
                        commit('SET_BANNER', item)
                    }else{
                        commit('SET_WEBSITE_BANNER', item)
                    }
                }
            })
        }else {
            MessageBox.confirm(result.message, "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                showCancelButton: false,
                type: "warning"
            })
        }
    },
    async disable_banner({commit}, check){
        commit('SET_BANNER_VISIBLE', false)
        if(check){
            $cookies.set('banner',{
                disabled : moment().format('YYYY-MM-DD')
            })
        }
    }
};
const mutations = {
    SET_BANNER(state, obj_info){
        state.banner_info = obj_info
        state.banner_info.banner_img = config.API_URL+obj_info.filepath
        state.banner_info.updated_at = moment(obj_info.updated_at).add(543,'Y').format('DD-MM-YYYY HH:mm:ss')
    },
    SET_WEBSITE_BANNER(state, obj_info){
        state.website_banner_info = obj_info
        state.website_banner_info.banner_img = config.API_URL+obj_info.filepath
        state.website_banner_info.updated_at = moment(obj_info.updated_at).add(543,'Y').format('DD-MM-YYYY HH:mm:ss')
    },
    SET_BANNER_VISIBLE(state, status){
        state.cms_banner_visible = status
    },
    SET_LOGIN_PENDING(state, status){
        state.login_pending = status
    }
};

export const Login_store = {
    namespaced: true,
    state,
    actions,
    mutations
};